import React, { Component } from "react";
import { SSOProfile } from "@10x/sso/SSOProfile";
import { navigate } from "@my-dld/utils/StoreUtils";
import { Redirect, Route, Switch } from "react-router";
import Search from "./Search";
import View from "./View";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import VaultContextWrapper from "../VaultContext";

class Vault extends Component<RoutedViewProps> {
	componentDidMount() {
		const profile = SSOProfile.getProfile();
		if ( profile == undefined ) {
			navigate( "/login" );
		}
	}

	render() {
		const pp = this.props.match.url;
		return <VaultContextWrapper>
			<Switch>
				<Route path={ pp + "/" } exact={ true }>
					<Redirect to={ pp + "/search" }/>
				</Route>
				<Route path={ pp + "/search" } component={ Search }/>
				<Route path={ pp + "/view" } component={ View }/>
			</Switch>
		</VaultContextWrapper>;
	}
}

export default Vault;
